import React, { useEffect, useState } from 'react';
import { assets, BRAND } from '../assets/branding';

// Brief branded launch splash — shown once per browser session for a premium
// native-app feel, then fades out. Non-blocking: it overlays and self-dismisses.
const SplashScreen = () => {
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem('rvx_splash_shown'); } catch (e) { return true; }
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem('rvx_splash_shown', '1'); } catch (e) { /* ignore */ }
    const fadeT = setTimeout(() => setFading(true), 1400);
    const doneT = setTimeout(() => setShow(false), 1900);
    return () => { clearTimeout(fadeT); clearTimeout(doneT); };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0b1f45] transition-opacity duration-500 ${fading ? 'opacity-0' : 'opacity-100'}`}
      data-testid="app-splash"
      role="status"
      aria-label="Loading ReasonVisionX"
    >
      {/* blueprint grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(47,155,255,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(47,155,255,0.08)_1px,transparent_1px)] bg-[size:44px_44px]" />
      {/* scan line */}
      <div className="absolute top-0 left-0 w-full h-0.5 bg-[#2f9bff] shadow-[0_0_18px_rgba(47,155,255,0.8)] animate-[rvxscan_2s_ease-in-out_infinite]" />

      <div className="relative flex flex-col items-center">
        <div className="bg-white/95 rounded-2xl p-5 shadow-2xl shadow-black/40 animate-[rvxpop_0.5s_ease-out]">
          <img src={assets.mark} alt={BRAND.productName} className="w-24 h-24 object-contain" />
        </div>
        <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-white font-display">{BRAND.productName}</h1>
        <p className="mt-1 text-sm text-white/70">{BRAND.tagline}</p>
      </div>

      <div className="absolute bottom-8 text-xs text-white/50">A product by REASON</div>
    </div>
  );
};

export default SplashScreen;
